import { fontSizes } from "healthex-common/sizes";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { FlexColumn } from "./common.styles";
import { HXMobileButton } from "./HXButton";
import { AnchorBlue, ContentContainer as HXContentContainer, Subtitle as HXSubtitle, LighterText } from "./HXMobilePage.styles";
export const ContentContainer = styled(HXContentContainer).attrs({ horizontalPadding: 16 }) `
    gap: 24px;
    padding-bottom: 24px;
`;
export const MediumSubtitle = styled(HXSubtitle) `
    font-size: ${fontSizes.MEDIUM};
`;
export const ConsentButton = styled(HXMobileButton) `
    border-color: ${colors.tulip_main};
    color: ${colors.tulip_main};
`;
const PatientStudyContactLink = styled(AnchorBlue) `
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    overflow-wrap: break-word;
`;
export const PatientStudyContactMailtoLink = PatientStudyContactLink;
export const PatientStudyContactExternalLink = PatientStudyContactLink;
export const PatientDetailsOrgBannerCircularContainer = styled.div `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 24px;
    overflow: hidden;
    background: ${colors.history_surface_bg};
    border-bottom: 1px solid ${colors.separator_main};
    margin: 0 -16px 0;
    align-self: stretch;
`;
export const PatientDetailsOrgBannerCircularImg = styled.img `
    position: relative;
    max-width: 100%;
    height: 120px;
    object-fit: contain;
`;
export const PatientDetailsOrgBannerRectangularContainer = styled.div `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: ${colors.history_surface_bg};
    border-bottom: 1px solid ${colors.separator_main};
    margin: 0 -16px 0;
    align-self: stretch;
    width: calc(100% + 32px);
    height: auto;
    aspect-ratio: 402 / 185;
`;
export const PatientDetailsOrgBannerRectangularImg = styled.img `
    position: relative;
    max-width: 100%;
    min-height: 100%;
    object-fit: contain;
`;
export const PatientStatusDescriptionText = styled(LighterText) `
    line-height: 24px;
    letter-spacing: -0.31px;
`;
export const ActivityTimelineList = styled(FlexColumn) `
    gap: 16px;
`;
export const ActivityTimelineRow = styled.div `
    display: flex;
    gap: 12px;
    align-items: stretch;
`;
export const ActivityTimelineRail = styled.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: 8px;
`;
export const ActivityTimelineDot = styled.div `
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => (props.isEmphasized ? colors.black_main : colors.separator_main)};
    flex-shrink: 0;
`;
export const ActivityTimelineConnector = styled.div `
    flex-grow: 1;
    margin: 4px 0 -16px;

    ${(props) => props.isDashed
    ? css `
                  width: 0;
                  border-left: 2px dashed ${colors.separator_main};
              `
    : css `
                  width: 2px;
                  background: ${colors.separator_main};
              `}

    ${(props) => props.isLast &&
    css `
            visibility: hidden;
        `}
`;
export const ActivityTimelineLabel = styled.p `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_main};
    font-weight: ${(props) => (props.isEmphasized ? fontWeights.BOLD : fontWeights.NORMAL)};
    margin: 0;
`;
export const ActivityTimelineDate = styled.p `
    font-size: ${fontSizes.TINY};
    color: ${colors.black_lighter};
    margin: 0;
`;
